import React, {Component} from 'react';
import {message, Popconfirm, Table} from 'antd';
import {Link} from 'react-router';
import moment from 'moment';
import {connect} from 'react-redux';
import {queryIncuBusinessArchve, queryIncuBusinessSigning} from '@api/incubator/business';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    const { contractTab, condition } = this.props;
    this.current = contractTab.concludePage || 1;
    this.pageSize = contractTab.concludePageSize || 10;
    this.condition = condition || {};
    this.getIncuBusinessSigning();
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.condition).some(key => nextProps.condition[key] !== this.condition[key])
    ) {
      this.condition = nextProps.condition;
      this.current = 1;
      this.getIncuBusinessSigning();
    }
  }

  getIncuBusinessSigning = () => {
    this.setState({
      loading: true,
    });
    const { pageSize } = this;
    queryIncuBusinessSigning({
      type: 'settled',
      limit: pageSize,
      start: this.current || 1,
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.props.onPageChange('settled', this.current, this.pageSize);
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              pageSize,
              total: res.totalSize,
              current: this.current,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: [10, 20, 50, 100],
            },
          },
          loading: false,
        });
      }
    });
  };

  incuBusinessArchve = businessUuid => {
    queryIncuBusinessArchve({
      businessUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getIncuBusinessArchving();
      } else {
        message.error(res.message);
      }
    });
  };

  onTableChange = pagination => {
    this.current = pagination.current;
    this.pageSize = pagination.pageSize;
    this.getIncuBusinessSigning();
  };

  columns = () => {
    const status = ['没有匹配', '完成匹配'];
    const termType = ['提前终止', '异常终止'];
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        width: 150,
        render: (text, record) => (
          <Link to={`/incubator/contract/${record.uuid}/info`}>{record.no}</Link>
        ),
      },
      {
        title: '企业名称',
        dataIndex: 'custom',
        width: 250,
      },
      {
        title: '合同周期',
        dataIndex: 'beginDate',
        width: 250,
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '工位数',
        dataIndex: 'num',
        width: 100,
      },
      {
        title: '款项状态',
        dataIndex: 'status',
        width: 100,
        render: text => <span>{status[text]}</span>,
      },
      {
        title: '合同情况',
        dataIndex: 'termType',
        width: 150,
        render: text => <span>{termType[text] || '正常'}</span>,
      },
      {
        title: '合同到期时间',
        dataIndex: 'deadline',
        width: 150,
        render: (text, record) => {
          let day = 0;
          if (text) {
            day = Math.floor((Date.now() - text) / 86400000);
          }

          const element =
            day > 0 ? (
              <p style={{ color: 'red', marginBottom: '0' }}>（逾期{day}天）</p>
            ) : (
              <p style={{ marginBottom: '0' }}>（剩余{Math.abs(day)}天）</p>
            );
          return (
            <span>
              {text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}
              {day ? element : ''}
            </span>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'termStatus', // 0审核中；1已完成
        width: 160,
        render: (text, record) => {
          return (
            <div>
              <div>
                <Popconfirm
                  title="确定归档所选合同吗？"
                  onConfirm={() => this.incuBusinessArchve(record.uuid)}
                >
                  <a>归档合同 </a>
                </Popconfirm>
              </div>

              {!(record.termStatus > 0 || record.termStatus === 0) ? (
                <Link to={`/incubator/contract/${record.uuid}/termination`}>终止合同</Link>
              ) : (
                <span>终止合同({record.termStatus === 0 ? '审核中' : '已完成'})</span>
              )}
            </div>
          );
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      loading,
    } = this.state;
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        rowKey="uuid"
        onChange={this.onTableChange}
        scroll={{ x: 1230 }}
        loading={loading}
      />
    );
  }
}

export default connect(state => ({ contractTab: state.contract_tab }))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/contract/station/TableConclude.js